import { useEffect, useState } from "react";
import { formatMoney } from "../../shared/money";
import { api } from "../api";
import { Banner, messageOf } from "./ui";

type Item = { id: string; name_en: string; name_el: string | null; category: string; selling_price_minor: number | null; internal_cost_minor: number | null };
type Pack = { id: string; code: string; name_en: string; name_el: string | null; pricing_mode: string; bundle_price_minor: number | null };

export function CataloguePage() {
  const [items, setItems] = useState<Item[]>([]);
  const [packages, setPackages] = useState<Pack[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api<{ items: Item[]; packages: Pack[] }>("/api/catalogue")
      .then((result) => {
        setItems(result.items);
        setPackages(result.packages);
      })
      .catch((reason: unknown) => setError(messageOf(reason)));
  }, []);

  return (
    <>
      <header className="page-head">
        <div>
          <h1>Κατάλογος</h1>
          <p className="lede">Τα συστατικά πακέτου που σημειώνονται ως συμπεριλαμβανόμενα περιγράφονται μέσα στην τιμή του πακέτου. Δεν χρεώνονται δεύτερη φορά. Οι τιμές δείγματος δεν είναι μενού.</p>
        </div>
      </header>
      <Banner error={error} />
      {!error && items.length === 0 && packages.length === 0 ? <p>Ο κατάλογος είναι άδειος.</p> : null}
      <div className="split">
        <section className="panel">
          <h2>Είδη</h2>
          <ul>
            {items.map((item) => (
              <li key={item.id}>{item.name_el || item.name_en} · {item.category} · {item.selling_price_minor == null ? "χωρίς τιμή" : formatMoney(item.selling_price_minor)} · κόστος {item.internal_cost_minor == null ? "άγνωστο" : formatMoney(item.internal_cost_minor)}</li>
            ))}
          </ul>
        </section>
        <section className="panel">
          <h2>Πακέτα</h2>
          <ul>
            {packages.map((pack) => (
              <li key={pack.id}>{pack.name_el || pack.name_en} · {pack.code} · {pack.pricing_mode}{pack.bundle_price_minor == null ? "" : ` · ${formatMoney(pack.bundle_price_minor)}`}</li>
            ))}
          </ul>
        </section>
      </div>
    </>
  );
}
